import React, { useState, useEffect, useRef } from 'react';
import pb from '../services/pocketbase';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const ADMIN_IDS = ['ct7ry76l5lk8f7v', '33ev0wtnwg7vdvs', 'xz5sudj5olp7nqd'];

function Blacklist() {
  const navigate = useNavigate();
  const currentUser = pb.authStore.model;
  const currentUserRole = currentUser?.userRole;
  const isVolunteer = currentUserRole === 'volunteer';
  const isAdmin = ADMIN_IDS.includes(currentUser?.id);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ phone: '', name: '', reason: '', city: '', address: '' });
  const [photos, setPhotos] = useState([]); // File[]
  const [photoPreviews, setPhotoPreviews] = useState([]); // base64[]
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [lightbox, setLightbox] = useState(null); // { url, index }
  const fileInputRef = useRef(null);

  useEffect(() => { fetchBlacklist(); }, []);

  const fetchBlacklist = async () => {
    setLoading(true);
    try {
      const records = await pb.collection('blacklist').getList(1, 100, { sort: '-created' });
      setEntries(records.items);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handlePhotoChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    const combined = [...photos, ...files].slice(0, 3); // макс 3 фото
    setPhotos(combined);
    // Генерируем превью
    const readers = combined.map(file => new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = (ev) => resolve(ev.target.result);
      reader.readAsDataURL(file);
    }));
    Promise.all(readers).then(setPhotoPreviews);
    // Сбрасываем input чтобы можно было выбрать тот же файл повторно
    e.target.value = '';
  };

  const removePhoto = (index) => {
    const newPhotos = photos.filter((_, i) => i !== index);
    const newPreviews = photoPreviews.filter((_, i) => i !== index);
    setPhotos(newPhotos);
    setPhotoPreviews(newPreviews);
  };

  const handleSubmit = async () => {
    if (!form.phone || !form.reason) { setError('Заполните телефон и причину'); return; }
    setSaving(true);
    setError('');
    try {
      const data = new FormData();
      data.append('phone', form.phone);
      data.append('name', form.name);
      data.append('reason', form.reason);
      data.append('city', form.city);
      data.append('address', form.address);
      data.append('addedBy', currentUser?.name || '');
      data.append('addedById', currentUser?.id || '');
      photos.forEach(file => data.append('photo', file));

      await pb.collection('blacklist').create(data);
      setForm({ phone: '', name: '', reason: '', city: '', address: '' });
      setPhotos([]);
      setPhotoPreviews([]);
      setShowForm(false);
      fetchBlacklist();
    } catch (e) {
      console.error(e);
      setError('Ошибка при добавлении');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить запись?')) return;
    try {
      await pb.collection('blacklist').delete(id);
      setEntries(prev => prev.filter(e => e.id !== id));
    } catch (e) {
      alert('Ошибка при удалении');
    }
  };

  const filtered = entries.filter(e => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (
      e.phone?.toLowerCase().includes(q) ||
      e.name?.toLowerCase().includes(q) ||
      e.city?.toLowerCase().includes(q) ||
      e.address?.toLowerCase().includes(q)
    );
  });

  const getPhotoUrl = (entry, filename) =>
    pb.files.getUrl(entry, filename, { thumb: '400x400' });

  return (
    <div style={{minHeight:'100vh', background:'#F5F7FA', paddingBottom:'80px'}}>
      {/* Header */}
      <div style={{background:'linear-gradient(135deg, #8B0000 0%, #C62828 100%)', padding:'15px 20px', color:'white'}}>
        <div style={{display:'flex', alignItems:'center', gap:'12px', marginBottom:'4px'}}>
          <div onClick={() => navigate(-1)} style={{fontSize:'24px', cursor:'pointer'}}>←</div>
          <div style={{fontSize:'20px', fontWeight:'700'}}>🚫 Чёрный список</div>
        </div>
        <div style={{display:'flex', alignItems:'center', background:'rgba(255,255,255,0.15)', borderRadius:'10px', padding:'8px 12px', gap:'8px'}}>
          <span style={{fontSize:'16px'}}>🔍</span>
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Поиск по телефону, имени, городу, адресу..."
            style={{background:'none', border:'none', outline:'none', color:'white', fontSize:'14px', flex:1}}
          />
          {search && (
            <span onClick={() => setSearch('')} style={{cursor:'pointer', fontSize:'16px', opacity:0.7}}>✕</span>
          )}
        </div>
      </div>

      {!isVolunteer && (
        <div style={{margin:'12px', background:'#FFF8E1', border:'1px solid #FFE082', borderRadius:'10px', padding:'12px', fontSize:'13px', color:'#7B5800'}}>
          ℹ️ Просматривать список может каждый. Добавлять записи могут только волонтёры.
        </div>
      )}

      {isVolunteer && !showForm && (
        <div style={{padding:'12px'}}>
          <button onClick={() => setShowForm(true)}
            style={{width:'100%', padding:'14px', background:'#C62828', color:'white', border:'none', borderRadius:'12px', fontSize:'15px', fontWeight:'600', cursor:'pointer'}}>
            ➕ Добавить в чёрный список
          </button>
        </div>
      )}

      {/* Форма добавления */}
      {isVolunteer && showForm && (
        <div style={{margin:'12px', background:'white', borderRadius:'12px', padding:'16px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <div style={{fontWeight:'700', fontSize:'16px', marginBottom:'12px'}}>Новая запись</div>
          {error && <div style={{color:'#C62828', marginBottom:'8px', fontSize:'13px'}}>{error}</div>}

          {[
            ['phone',   '📞 Телефон *',              'tel',  '+7 (___) ___-__-__'],
            ['name',    '👤 Имя (если известно)',     'text', 'ФИО или псевдоним'],
            ['city',    '📍 Город',                   'text', 'Красноярск, Новосибирск...'],
            ['address', '🏠 Адрес',                   'text', 'Улица, район, ориентир...'],
            ['reason',  '⚠️ Причина добавления *',   'text', 'Опишите ситуацию...'],
          ].map(([field, label, type, placeholder]) => (
            <div key={field} style={{marginBottom:'10px'}}>
              <div style={{fontSize:'13px', color:'#666', marginBottom:'4px'}}>{label}</div>
              {field === 'reason' ? (
                <textarea value={form[field]} onChange={e => setForm({...form, [field]: e.target.value})}
                  placeholder={placeholder} rows={3}
                  style={{width:'100%', padding:'10px', border:'1px solid #E0E0E0', borderRadius:'8px', fontSize:'14px', resize:'none', boxSizing:'border-box', fontFamily:'inherit'}} />
              ) : (
                <input type={type} value={form[field]} onChange={e => setForm({...form, [field]: e.target.value})}
                  placeholder={placeholder}
                  style={{width:'100%', padding:'10px', border:'1px solid #E0E0E0', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box'}} />
              )}
            </div>
          ))}

          {/* Загрузка фото */}
          <div style={{marginBottom:'12px'}}>
            <div style={{fontSize:'13px', color:'#666', marginBottom:'8px'}}>📷 Фото (до 3 шт.)</div>

            {/* Превью выбранных фото */}
            {photoPreviews.length > 0 && (
              <div style={{display:'flex', gap:'8px', marginBottom:'8px', flexWrap:'wrap'}}>
                {photoPreviews.map((src, i) => (
                  <div key={i} style={{position:'relative'}}>
                    <img src={src} alt=""
                      style={{width:'80px', height:'80px', objectFit:'cover', borderRadius:'8px', border:'2px solid #E0E0E0'}} />
                    <button
                      onClick={() => removePhoto(i)}
                      style={{
                        position:'absolute', top:'-6px', right:'-6px',
                        width:'20px', height:'20px', borderRadius:'50%',
                        background:'#C62828', color:'white', border:'none',
                        cursor:'pointer', fontSize:'12px', fontWeight:'700',
                        display:'flex', alignItems:'center', justifyContent:'center',
                        lineHeight:1,
                      }}>✕</button>
                  </div>
                ))}
              </div>
            )}

            {photos.length < 3 && (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handlePhotoChange}
                  style={{display:'none'}}
                />
                <button
                  onClick={() => fileInputRef.current?.click()}
                  style={{
                    padding:'10px 16px', border:'2px dashed #E0E0E0', borderRadius:'8px',
                    background:'#FAFAFA', color:'#666', cursor:'pointer', fontSize:'13px',
                    display:'flex', alignItems:'center', gap:'6px',
                  }}>
                  📎 {photos.length === 0 ? 'Прикрепить фото' : 'Добавить ещё'}
                </button>
              </>
            )}
          </div>

          <div style={{display:'flex', gap:'8px', marginTop:'4px'}}>
            <button onClick={() => { setShowForm(false); setPhotos([]); setPhotoPreviews([]); setError(''); }}
              style={{flex:1, padding:'12px', background:'#F5F5F5', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'14px'}}>
              Отмена
            </button>
            <button onClick={handleSubmit} disabled={saving}
              style={{flex:2, padding:'12px', background:'#C62828', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'14px', fontWeight:'600'}}>
              {saving ? 'Сохранение...' : '✓ Добавить'}
            </button>
          </div>
        </div>
      )}

      {search.trim() && (
        <div style={{padding:'0 12px 8px', fontSize:'13px', color:'#666'}}>
          Найдено: {filtered.length} {filtered.length === 1 ? 'запись' : filtered.length >= 2 && filtered.length <= 4 ? 'записи' : 'записей'}
        </div>
      )}

      {/* Список */}
      <div style={{padding:'0 12px'}}>
        {loading ? (
          <div style={{textAlign:'center', padding:'40px', color:'#999'}}>Загрузка...</div>
        ) : filtered.length === 0 ? (
          <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
            <div style={{fontSize:'48px'}}>{search ? '🔍' : '✅'}</div>
            <p>{search ? 'Ничего не найдено' : 'Чёрный список пуст'}</p>
          </div>
        ) : (
          filtered.map(entry => (
            <div key={entry.id} style={{background:'white', borderRadius:'12px', padding:'14px', marginBottom:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)', borderLeft:'4px solid #C62828'}}>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
                <div style={{flex:1}}>
                  <div style={{display:'flex', alignItems:'center', gap:'8px', marginBottom:'6px'}}>
                    <span style={{fontSize:'18px'}}>🚫</span>
                    <span style={{fontWeight:'700', fontSize:'16px'}}>{entry.phone}</span>
                  </div>
                  {entry.name && <div style={{fontSize:'14px', color:'#333', marginBottom:'4px'}}>👤 {entry.name}</div>}
                  {entry.city && <div style={{fontSize:'13px', color:'#666', marginBottom:'4px'}}>📍 {entry.city}</div>}
                  {entry.address && <div style={{fontSize:'13px', color:'#666', marginBottom:'4px'}}>🏠 {entry.address}</div>}
                  <div style={{fontSize:'13px', color:'#555', background:'#FFF5F5', padding:'8px', borderRadius:'6px', marginTop:'6px'}}>
                    ⚠️ {entry.reason}
                  </div>

                  {/* Фото в карточке */}
                  {entry.photo && entry.photo.length > 0 && (
                    <div style={{display:'flex', gap:'6px', marginTop:'10px', flexWrap:'wrap'}}>
                      {(Array.isArray(entry.photo) ? entry.photo : [entry.photo]).map((filename, i) => (
                        <img
                          key={i}
                          src={getPhotoUrl(entry, filename)}
                          alt=""
                          onClick={() => setLightbox({ entry, index: i })}
                          style={{width:'72px', height:'72px', objectFit:'cover', borderRadius:'8px', cursor:'pointer', border:'2px solid #FFCDD2'}}
                        />
                      ))}
                    </div>
                  )}

                  <div style={{fontSize:'11px', color:'#999', marginTop:'8px'}}>
                    Добавил: {entry.addedBy} • {new Date(entry.created).toLocaleDateString('ru-RU')}
                  </div>
                </div>
                {(isAdmin || (isVolunteer && entry.addedById === currentUser?.id)) && (
                  <button onClick={() => handleDelete(entry.id)}
                    style={{background:'none', border:'none', cursor:'pointer', fontSize:'18px', padding:'4px', marginLeft:'8px'}}>
                    🗑️
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Лайтбокс */}
      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position:'fixed', inset:0, background:'rgba(0,0,0,0.85)',
            zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center',
            padding:'20px',
          }}>
          <div onClick={e => e.stopPropagation()} style={{position:'relative', maxWidth:'100%', maxHeight:'90vh'}}>
            <img
              src={pb.files.getUrl(lightbox.entry, (Array.isArray(lightbox.entry.photo) ? lightbox.entry.photo : [lightbox.entry.photo])[lightbox.index])}
              alt=""
              style={{maxWidth:'100%', maxHeight:'80vh', borderRadius:'10px', objectFit:'contain'}}
            />
            <button
              onClick={() => setLightbox(null)}
              style={{
                position:'absolute', top:'-12px', right:'-12px',
                width:'32px', height:'32px', borderRadius:'50%',
                background:'white', border:'none', cursor:'pointer',
                fontSize:'18px', fontWeight:'700', color:'#333',
                display:'flex', alignItems:'center', justifyContent:'center',
                boxShadow:'0 2px 8px rgba(0,0,0,0.3)',
              }}>✕</button>
            {/* Навигация если фото несколько */}
            {Array.isArray(lightbox.entry.photo) && lightbox.entry.photo.length > 1 && (
              <div style={{display:'flex', justifyContent:'center', gap:'8px', marginTop:'12px'}}>
                {lightbox.entry.photo.map((_, i) => (
                  <div key={i}
                    onClick={() => setLightbox({...lightbox, index: i})}
                    style={{width:'8px', height:'8px', borderRadius:'50%', background: i === lightbox.index ? 'white' : 'rgba(255,255,255,0.4)', cursor:'pointer'}} />
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <BottomNav />
    </div>
  );
}

export default Blacklist;
